<script setup>
import { computed, onBeforeUnmount, onMounted } from "vue";

import AppSidebar from "./AppSidebar.vue";
import AppTopbar from "./AppTopbar.vue";

import { useLayout } from "@/layout/composables/layout";

const {
  layoutConfig,
  layoutState,
  watchSidebarActive,
  unbindOutsideClickListener,
} = useLayout();

onMounted(() => {
  watchSidebarActive();
});

onBeforeUnmount(() => {
  unbindOutsideClickListener();
});

const containerClass = computed(() => {
  return {
    "layout-light": !layoutConfig.darkTheme,
    "layout-dark": layoutConfig.darkTheme,
    "layout-colorscheme-menu": layoutConfig.menuTheme === "colorScheme",
    "layout-primarycolor-menu": layoutConfig.menuTheme === "primaryColor",
    "layout-transparent-menu": layoutConfig.menuTheme === "transparent",
    "layout-overlay": layoutConfig.menuMode === "overlay",
    "layout-static": layoutConfig.menuMode === "static",
    "layout-slim": layoutConfig.menuMode === "slim",
    "layout-slim-plus": layoutConfig.menuMode === "slim-plus",
    "layout-horizontal": layoutConfig.menuMode === "horizontal",
    "layout-reveal": layoutConfig.menuMode === "reveal",
    "layout-drawer": layoutConfig.menuMode === "drawer",
    "layout-static-inactive":
      layoutState.staticMenuDesktopInactive &&
      layoutConfig.menuMode === "static",
    "layout-overlay-active": layoutState.overlayMenuActive,
    "layout-mobile-active": layoutState.staticMenuMobileActive,
    "layout-sidebar-active": layoutState.sidebarActive,
    "layout-sidebar-anchored": layoutState.anchored,
  };
});
</script>

<template>
  <div
    :class="[
      'layout-container',
      { ...containerClass },
      'bg-surface-50 dark:bg-surface-900',
      'flex h-screen',
    ]"
  >
    <AppSidebar />

    <div class="layout-content-wrapper flex flex-col flex-grow">
      <AppTopbar class="w-full" />
      <div
        class="screen-wide-card-wrapper flex-grow flex justify-center overflow-hidden"
      >
        <div
          class="screen-wide-card bg-surface-0 dark:bg-surface-800 rounded-lg overflow-y-auto h-full max-h-full w-full border p !border-surface-300 dark:!border-surface-600"
        >
          <div class="layout-content h-full">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>

    <div class="layout-mask"></div>
  </div>
</template>
